export default __webpack_public_path__ + "static/media/awaiting2F.a5526db8.svg";